module.exports = __webpack_public_path__ + "img/money.6f44f568.png";